<template>
  <a-dialog ref="dialog" size="small" name="remove_urls" :loading="loading" @open="opened" @close="$reset">
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content">
      {{ $t('content') }}<code>{{ ids.length }}</code> {{ $t('content-url') }}
    </div>
    <span slot="actions">
      <v-btn color="error" text @click="submit">
        {{ $t('actions.remove') }} {{ ids.length }} {{ $t('url') }}
      </v-btn>
    </span>
  </a-dialog>
</template>

<script>
export default {
  name: 'RemoveUrlsDialog',
  data () {
    return {
      loading: '',
      ids: []
    }
  },
  methods: {
    opened ({ ids }) {
      this.ids = ids
    },
    async submit () {
      this.loading =  this.$t('remove')

      try {
        await this.$api.post('url-monitors/remove', { ids: this.ids })
        this.$ui.success(this.$t('success'))
        this.$bus.emit('url-monitoring/require_refresh')
        if (this.$refs.dialog) this.$refs.dialog.close()
      } finally {
        this.loading = ''
      }
    }
  }
}
</script>

<i18n>
{
	"en": {
		"content": "Are you sure you want to delete",
		"content-url": " URL ? This action is irreversible.",
		"remove": "Removing URLs ...",
		"success": "URLs have been deleted successfully.",
		"title": "Remove URLs",
		"url": "URL"
	},
	"es": {
		"content": "Estas seguro que quieres borrar",
		"content-url": "URL ? Esta acción es irreversible.",
		"remove": "Eliminando URL ...",
		"success": "Las URL se han eliminado correctamente.",
		"title": "Borrar URL",
		"url": "URL"
	},
	"fr": {
		"content": "Souhaitez-vous réellement supprimer ",
		"content-url": " URL ? Cette action est irreversible.",
		"remove": "Suppression des URL ...",
		"success": "Les URL ont été supprimés avec succès.",
		"title": "Supprimer des URL",
		"url": "URL"
	},
	"it": {
		"content": "Sei sicuro di voler eliminare",
		"content-url": " URL ? Questa azione è irreversibile.",
		"remove": "Eliminazione URL ...",
		"success": "Gli URL sono stati eliminati con successo.",
		"title": "Rimuovi URL",
		"url": "URL"
	},
	"pt": {
		"content": "Tem a certeza de que deseja eliminar",
		"content-url": " URL ? Esta ação é irreversível.",
		"remove": "A eliminar URLs ...",
		"success": "Os URLs foram eliminados com sucesso.",
		"title": "Remover URLs",
		"url": "URL"
	},
	"pl": {
		"content": "Czy na pewno chcesz usunąć",
		"content-url": " URL ? Ta akcja jest nieodwracalna.",
		"remove": "Usuwanie URL ...",
		"success": "URL-e zostały pomyślnie usunięte.",
		"title": "Usuń URL-e",
		"url": "URL"
	}
}
</i18n>

